module.exports = __webpack_public_path__ + "static/media/computer.cb2c2df1.svg";